import styled from 'styled-components';

const Title = styled.div`
  ${({ theme }) => theme.fontFamily.secondaryFont.mediumRegular}
  color: ${({ theme }) => theme.colors.textPrimary};
  line-height: ${({ theme }) => theme.spaces.space_16};
  overflow: hidden;
  position: relative;
  margin: ${({ theme }) => theme.spacing(6, 0, 1, 0)};
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-width: 80%;
`;

export default Title;
